// Public CMS reads — merge admin-authored content with built-in static content.
// All calls are resilient: on any failure they return empty so static content
// still renders (the public pages never break if the backend is unavailable).
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function safeGet(path) {
  try {
    const res = await fetch(`${BASE}${path}`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

export const cmsService = {
  articles: async () => (await safeGet("/blog/articles"))?.items || [],
  article: async (slug) => await safeGet(`/blog/articles/${slug}`),
  guides: async () => (await safeGet("/help/guides"))?.items || [],
  faqs: async () => (await safeGet("/help/faqs"))?.items || [],
};

export default cmsService;
